import React, { useState, useEffect } from "react";
import styles from "./need.module.css";
import profile1 from "../../assets/User-avatar.png";
import place from "../../assets/place.png";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiBaseURL } from "../../utils/axios";
import { FaSearch } from "react-icons/fa";
import Loader from "../../components/loader/Loader";
import Swal from "sweetalert2";
import Empty from "../../assets/illustration_empty_content.svg";
import ReactPaginate from "react-paginate";
import { Helmet } from "react-helmet";

const NeedBlood = () => {
  const [donors, setDonors] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const [search, setSearch] = useState("");
  const [error, setError] = useState(null);

  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [currentDonor, setCurrentDonor] = useState([]);

  const donorsPerPage = 6;

  // Scroll the page to the top when it loads
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);

  // Fetch Donor List when the page loads

  useEffect(() => {
    setIsPending(true);

    let cancel;

    // Function to make the request to the setver

    const getDonors = async () => {
      try {
        const response = await axios.get(`${apiBaseURL}/v1/donors`, {
          cancelToken: new axios.CancelToken(function executor(c) {
            cancel = c;
          }),
        });
        setIsPending(false);
        setDonors(response.data.users);
      } catch (error) {

        if (axios.isCancel(error)) {
          setError(error);
        } else {
          setIsPending(false);
        }

      }
    };
    getDonors();
    return () => {
      if (cancel) {
        cancel("Request canceled due to component unmount");
      }
    };
  }, []);

  // For Pagination

  useEffect(() => {
    const endOffset = itemOffset + donorsPerPage;
    setCurrentDonor(donors.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(donors.length / donorsPerPage));
  }, [itemOffset, donorsPerPage, donors]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * donorsPerPage) % donors.length;
    setItemOffset(newOffset);
  };

  return (
    <div className="mx-auto max-w-[1380px]">
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Need Blood | RIBI BLOOD</title>
          <link rel="canonical" href="https://ribiblood.com/need-blood" />
        </Helmet>
        {/* Top Hero */}

        <div className="shadow border-t-2 border-slate-200">
          <div className="flex justify-center items-center text-center py-32 lg:px-4 px-8">
            <p className="text-[#f6655f] text-4xl leading-normal font-bold uppercase">
              search and request for blood
            </p>
          </div>
        </div>

        <div className="py-12 lg:pt-20 font-poppins">
          <p className="font-bold lg:text-4xl text-2xl px-2 text-[#f6655f] text-center ">
            Find Blood Donors Here
          </p>
          <p className="text-center text-xs px-8 text-slate-600 my-3">
            Search with Blood type (e.g. O, O+, A, A+, B) Or with state/city
          </p>

          <form className={`${styles.findDonor} bg-red-100`}>
            <div className="flex items-center w-full justify-center lg:px-12 px-2">
              <label htmlFor="" className="relative w-full">
                {" "}
                <FaSearch className="text-2xl text-slate-400 absolute left-5 z-20 top-1/3" />
                <input
                  className={`${styles.donorSearch} flex-1 `}
                  type="search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  placeholder="Search with Lagos or Ikeja or A+"
                  title="Search with Blood type (e.g. O, O+, A, A+, B) Or with state/city"
                />
              </label>
            </div>
          </form>
          {/* Result Displayed */}
          <div className="">
            <h2 className={`${styles.availableDonorTitle} py-4`}>
              Available Donors
            </h2>

            <div
              className={`${styles.availableDonorContainer} lg:px-[2rem] py-8 px-[10px]`}
            >
              {isPending && <Loader />}

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 p-2.5 mx-auto">
                {search
                  ? donors
                      .filter(
                        (item) =>
                          item.bloodType
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1 ||
                          item.city
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1 ||
                          item.state
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1
                      )
                      // .slice(0, donorsPerPage)
                      .map((item) => (
                        <div key={item._id} className={styles.donorItem}>
                          <Link
                            className={`${styles.link} hover:bg-blue-200 hover:shadow-lg py-4 px-3 rounded-lg`}
                            to={`/donor-request/${item._id}`}
                          >
                            <div style={{ width: "60px", height: "60px" }}>
                              <img
                                style={{
                                  height: `100%`,
                                  width: `100%`,
                                  borderRadius: `50%`,
                                }}
                                src={item.avater ? item.avater : profile1}
                                alt={item.name}
                                onError={(event) => {
                                  event.target.src =
                                    "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                                  event.onerror = null;
                                }}
                              />
                            </div>

                            <h5 className={styles.profileName}>
                              {item.firstname} {item.lastname}
                            </h5>

                            <div className={styles.location}>
                              <img
                                className={styles.place}
                                src={place}
                                alt="place"
                              />
                              <p
                                className={`${styles.locationName} first-letter:uppercase`}
                              >
                                {item.state} State
                              </p>
                            </div>
                            <p
                              className={`${styles.city} first-letter:uppercase`}
                            >
                              {item.city}
                            </p>
                            <div className={styles.bloodGroupContainer}>
                              <h4 className={styles.bloodGroup}>
                                {item.bloodType}
                              </h4>
                            </div>
                          </Link>
                        </div>
                      ))
                  : currentDonor.map((item) => (
                      <div key={item._id} className={styles.donorItem}>
                        <Link
                          className={`${styles.link} hover:bg-blue-200 hover:shadow-lg py-4 px-3 rounded-lg`}
                          to={`/donor-request/${item._id}`}
                        >
                          <div style={{ width: "60px", height: "60px" }}>
                            <img
                              style={{
                                height: `100%`,
                                width: `100%`,
                                borderRadius: `50%`,
                              }}
                              src={item.avater ? item.avater : profile1}
                              alt={item.name}
                              onError={(event) => {
                                event.target.src =
                                  "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                                event.onerror = null;
                              }}
                            />
                          </div>

                          <h5 className={styles.profileName}>
                            {item.firstname} {item.lastname}
                          </h5>

                          <div className={styles.location}>
                            <img
                              className={styles.place}
                              src={place}
                              alt="place"
                            />
                            <p
                              className={`${styles.locationName} first-letter:uppercase`}
                            >
                              {item.state} State
                            </p>
                          </div>
                          <p
                            className={`${styles.city} first-letter:uppercase`}
                          >
                            {item.city}
                          </p>
                          <div className={styles.bloodGroupContainer}>
                            <h4 className={styles.bloodGroup}>
                              {item.bloodType}
                            </h4>
                          </div>
                        </Link>
                      </div>
                    ))}
              </div>

              {error &&
                Swal.fire({
                  icon: "info",
                  text: `${error}`,
                  confirmButtonText: "Try Again",
                })}

              {donors.length < 0 && (
                <div className="wrapper p-6">
                  <div className="empty px-4 flex flex-col justify-center items-center h-full">
                    <span className="">
                      <img src={Empty} alt="Emptty data icon" srcset="" />
                    </span>
                    <h5 className=" text-xl font-bold my-3 text-center">
                      No Available Donor
                    </h5>
                  </div>
                </div>
              )}
            </div>

            <ReactPaginate
              breakLabel="..."
              nextLabel=" Next"
              previousLabel="Previous"
              onPageChange={handlePageClick}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              pageRangeDisplayed={2}
              renderOnZeroPageCount={null}
              containerClassName=" flex justify-center space-x-3 my-4"
              pageClassName="hover:bg-[#f6655f] rounded-md hover:text-white px-3 py-2"
              previousClassName="bg-[#f6655f] text-white rounded-lg px-3 py-2"
              nextClassName="bg-[#f6655f] text-white rounded-lg px-3 py-2"
              activeClassName="bg-[#f6655f] text-white font-bold rounded-md"
              disabledClassName="bg-gray-400 hover:bg-[gray] text-black"
              disabledLinkClassName="cursor-not-allowed"
            />
          </div>
        </div>
      </>
    </div>
  );
};

export default NeedBlood;
